// extracted by mini-css-extract-plugin
export default {"button":"AddTextObjectButton_button__tAdaA"};